import { inject, Service } from '@angular/core';
import {Observable, Subject} from 'rxjs';
import {Entity} from '../entity/entity';
import {PersonService} from './person-service';
import {EntityService} from './entity-service';
import {Person} from '../person/person';

@Service()
export class SkyportValidationService {
  private readonly personService = inject(PersonService);
  private readonly entityService = inject(EntityService);


  getSkyportContactError(order: Entity): Observable<string> {
    const subject = new Subject<string>();
    this.entityService.hasSkyportCharacteristic(order.id).subscribe({
      next: (isPresent: string) => {
        if (isPresent && isPresent === 'true') {
          this.personService.getSkyportContact(order).subscribe({
            next: (skyportContact: Person) => {
              if (!skyportContact || !skyportContact.personId || skyportContact.personId.trim().length === 0) {
                subject.next('At least one line on this quote has IEC Skyport Processing selected.' +
                  ' You must enter a valid Skyport Contact before submitting order for review.');
              } else {
                subject.next('');
              }
              subject.complete();
            }, error: (error) => this.handleError(subject, error)
          });
        } else {
          subject.next('');
          subject.complete();
        }
      }, error: (error) => this.handleError(subject, error)
    });
    return subject.asObservable();
  }

  private handleError(subject: Subject<any>, error: any) {
    subject.error(error);
    subject.complete();
  }

}
